<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container">
      <div class="navbar_left" @click="toHome">
        <img src="@/assets/jsht/home/logo.png" alt />
      </div>
      <div class="navbar_right">
        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          background-color="#ffffff"
          :text-color="'#1E1E1E'"
          :active-text-color="'#0C6AEC'"
          @select="changeCurrentPage"
        >
          <el-menu-item index="home" class="menu_item">
            <span class="menu_item_index">
              <img v-if="$route.path.indexOf('/home')>-1" src="./../../assets/jsht/首页1.png" alt />
              <img v-else src="./../../assets/jsht/首页0.png" alt />
              首页
            </span>
          </el-menu-item>
          
          <el-submenu popper-append-to-body index="xm" class="menu_item">
            <template slot="title">
              <span class="menu_item_index">
                <img v-if="$route.path.indexOf('/xm')>-1" src="./../../assets/jsht/项目1.png" alt />
                <img v-else src="./../../assets/jsht/项目0.png" alt />
                项目
              </span>
            </template>
            <el-submenu index="xm-zczr" class="menu_item">
              <template slot="title">资产转让</template>
              <el-menu-item index="xm-zczr-1">房屋</el-menu-item>
              <el-menu-item index="xm-zczr-2">设备物资</el-menu-item>
              <!-- <el-menu-item index="xm-zczr-3">物资</el-menu-item> -->
              <el-menu-item index="xm-zczr-3">车辆</el-menu-item>
              <el-menu-item index="xm-zczr-4">其他</el-menu-item>
            </el-submenu>
            <el-submenu index="xm-zczl" class="menu_item">
              <template slot="title">资产租赁</template>
              <el-menu-item index="xm-zczl-5">房屋</el-menu-item>
              <!-- <el-menu-item index="xm-zczl-7">土地</el-menu-item> -->
              <el-menu-item index="xm-zczl-6">场地区域</el-menu-item>
              <el-menu-item index="xm-zczl-7">设备</el-menu-item>
              <el-menu-item index="xm-zczl-8">其他</el-menu-item>
            </el-submenu>
            <el-submenu index="xm-zhjy" class="menu_item">
              <template slot="title">综合交易</template>
              <el-menu-item index="xm-zhjy-9">特许经营权</el-menu-item>
              <el-menu-item index="xm-zhjy-10">债权</el-menu-item>
              <el-menu-item index="xm-zhjy-11">数据信息</el-menu-item>
              <el-menu-item index="xm-zhjy-12">专栏</el-menu-item>
            </el-submenu>
            <el-submenu index="xm-nccq" class="menu_item">
              <template slot="title">农村产权</template>
              <el-menu-item index="xm-nccq-13">房屋</el-menu-item>
              <el-menu-item index="xm-nccq-14">土地</el-menu-item>
              <el-menu-item index="xm-nccq-15">设备</el-menu-item>
              <el-menu-item index="xm-nccq-16">其他</el-menu-item>
            </el-submenu>
            <el-submenu index="xm-ygzb" class="menu_item">
              <template slot="title">阳光招标</template>
              <el-menu-item index="xm-ygzb-17">工程项目</el-menu-item>
              <el-menu-item index="xm-ygzb-18">采购项目</el-menu-item>
            </el-submenu>
            <el-menu-item index="xm-zstj" class="menu_item">招商推介</el-menu-item>
            <el-menu-item index="xm-cjgs">成交公示</el-menu-item>
            <!-- <el-submenu index="xm-cjgs" class="menu_item">
              <template slot="title">成交公示</template>
              
            </el-submenu> -->
          </el-submenu>
          <el-submenu index="jj" class="menu_item">
            <template slot="title">
              <span class="menu_item_index">
                <img v-if="$route.path.indexOf('/jj')>-1" src="./../../assets/jsht/竞价1.png" alt />
                <img v-else src="./../../assets/jsht/竞价0.png" alt />
                竞价
              </span>
            </template>
            <el-menu-item index="jj-zcfg-4" class="menu_item">政策法规</el-menu-item>
            <el-menu-item index="jj-jylc-5" class="menu_item">交易流程</el-menu-item>
            <el-menu-item index="jj-jjxz-6" class="menu_item">竞价须知</el-menu-item>
            <el-menu-item index="jj-wjxz-7" class="menu_item">文件下载</el-menu-item>
          </el-submenu>
          <el-submenu index="hd">
            <template slot="title">
              <span class="menu_item_index">
                <img v-if="$route.path.indexOf('/hd')>-1" src="./../../assets/jsht/互动1.png" alt />
                <img v-else src="./../../assets/jsht/互动0.png" alt />
                互动
              </span>
            </template>
            <el-menu-item index="hd-qywh" class="menu_item">企业文化</el-menu-item>
            <el-menu-item index="hd-lxwm" class="menu_item">联系我们</el-menu-item>
            <!-- <el-menu-item index="hd-zxzx" class="menu_item">在线咨询</el-menu-item> -->
          </el-submenu>
          <el-submenu index="zx">
            <template slot="title">
              <span class="menu_item_index">
                <img v-if="$route.path.indexOf('/zx')>-1" src="./../../assets/jsht/咨询.png" alt />
                <img v-else src="./../../assets/jsht/咨询0.png" alt />
                资讯
              </span>
            </template>
            <el-menu-item index="zx-gsdt-1" class="menu_item">公司动态</el-menu-item>
            <el-menu-item index="zx-hyzx-2" class="menu_item">行业资讯</el-menu-item>
            <el-menu-item index="zx-tzgg-3" class="menu_item">通知公告</el-menu-item>
          </el-submenu>



          <el-menu-item index="tsfw" class="menu_item">
            <span class="menu_item_index">
              <img v-if="$route.path.indexOf('/tsfw')>-1" src="./../../assets/jsht/特色服务1.png" alt />
              <img v-else src="./../../assets/jsht/特色服务0.png" alt />
              特色服务
            </span>
          </el-menu-item>
        </el-menu>
        <!-- <a href="#">立即体验</a> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '',
      navBackground: ''
    }
  },
  props: {},
  watch: {
    $route(to, from) {
      this.activeIndex = to.path
      .split('/')
      .filter(item => {
        return item
      })
      .join('-')
      // 在路由变化时执行的操作
    }
  },
  mounted() {
    
  },
  methods: {
    toHome(){
      this.$router.push({
        path: '/home'
      })
    },
    changeCurrentPage(index) {
      let path = '/' + index.replaceAll('-', '/')
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 80px;
  background: #ffffff;
  backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  .navbar_container {
    // width: 70%;
    min-width: 1440px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;

      img {
        width: 344px;
        height: 54px;
        cursor: pointer;
      }
    }

    .navbar_right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 20px;

      // a {
      //   text-decoration: none;
      //   color: #0038a4;
      //   display: inline-block;
      //   width: 100px;
      //   background: #ffa400;
      //   line-height: 27px;
      //   text-align: center;
      //   border-radius: 20px;
      //   padding: 5px;
      // }

      .el_menu_demo {
        border: none;
        font-weight: 600;
      }

      .menu_item {
        // &:hover {
        //   font-weight: 600;
        //   background: transparent !important;
        // }
      }

      .right_phone {
        &:hover {
          color: #ccc;
        }

        transition: all 0.5s;
        display: flex;
        align-items: center;

        i {
          font-size: 20px;
        }

        span {
          margin-left: 0.5rem;
        }

        margin-left: 2.5rem;
        color: #fff;
      }
    }
  }
}
.menu_item_index {
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
}



</style>